<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="设备编号">
                <a-input v-model="queryParam.deviceCode" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="设备类型">
                <a-select v-model="queryParam.deviceTypeId" placeholder="请选择" show-search allow-clear :filter-option="filterOption" @focus="handleFocus" @blur="handleBlur" @change="handleChange">
                  <a-select-option v-for="(item,key) in typeList" :key="key" :value="item.id">{{ item.name }}（{{item.code}}）</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客户名称">
                <a-select v-model="queryParam.customId" placeholder="请选择" show-search allow-clear :filter-option="filterOption" @focus="handleFocus" @blur="handleBlur" @change="handleChange">
                  <a-select-option v-for="(item,key) in customList" :key="key" :value="item.id">{{ item.name }}（{{item.number}}）</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="创建时间">
                  <a-range-picker style="width: 100%" v-model="dateRange" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['up:abnormalrecord:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['up:abnormalrecord:edit']">
          <a-icon type="edit" />修改
        </a-button> -->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['up:abnormalrecord:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="danger" @click="handleClear" v-hasPermi="['up:abnormalrecord:clear']">
          <a-icon type="delete" />清空
        </a-button>
        <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['up:abnormalrecord:export']">
          <a-icon type="download" />导出
        </a-button> -->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :scroll="{ x: 1500, y: 500 }"
        :bordered="tableBordered">
        <span slot="deviceType" slot-scope="text, record">
          {{ record.deviceType }}（{{ record.deviceTypeCode }}）
        </span>
        <span slot="customName" slot-scope="text, record">
          {{ record.customName }}（{{ record.customNumber }}）
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['up:abnormalrecord:remove']"/>-->
          <a @click="handleDelete(record)" v-hasPermi="['up:abnormalrecord:remove']">
            <a-icon type="edit" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        :page-size-options="pageSizeOptions"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>

import { deviceFaultPage, deviceFaultDelete, deviceFaultClear, deviceTypeList, customList } from '@/api/pages/device'

import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Config',
  mixins: [tableMixin],
  dicts: ['sys_yes_no'],
  data () {
    return {
      typeList: [],
      customList: [],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      refreshing: false,
      total: 0,
      // 日期范围
      dateRange: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        dataInfoId: undefined
      },
      pageSizeOptions: ['10', '20', '30', '40', '50', '100'],
      columns: [
        {
          title: '设备编号',
          dataIndex: 'deviceCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设备类型1',
          dataIndex: 'deviceType',
          scopedSlots: { customRender: 'deviceType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '客户名称',
          dataIndex: 'customName',
          scopedSlots: { customRender: 'customName' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作人',
          dataIndex: 'operatorUserName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作内容',
          dataIndex: 'operatorContent',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 80,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ].filter(column => {
        // 根据条件过滤列
        if (column.dataIndex === 'operation'){
          const permissions = this.$store.state.user.permissions
          if (permissions.includes("*:*:*")
            || permissions.includes("up:abnormalrecord:remove")) {
            return true
          }
          return false
        }
        return true
      })
    }
  },
  filters: {
  },
  created () {
    deviceTypeList().then(response => {
      this.typeList = response.data
    })
    customList().then(response => {
      this.customList = response.data
    })
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询参数列表 */
    getList () {
      this.loading = true
      if (this.dateRange !== null && this.dateRange !== '' && this.dateRange.length === 2) {
        this.queryParam.createBeginTime = this.dateRange[0] + ' 00:00:00'
        this.queryParam.createEndTime = this.dateRange[1] + ' 23:59:59'
      }
      deviceFaultPage(this.queryParam).then(response => {
          this.list = response.data.records
          this.total = response.data.total
          this.loading = false
        }
      )
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.dateRange = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        dataInfoId: null
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const configIds = row.id ? [row.id] : this.ids
      this.$confirm({
        title: '确认处理所选中数据?',
        content: '当前选中编号为' + configIds + '的数据',
        onOk () {
          return deviceFaultDelete(configIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '处理成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    // 清空
    handleClear () {
      var that = this
      this.$confirm({
        title: '是否确认清空?',
        content: '此操作将会清空所有操作日志数据项',
        onOk () {
          return deviceFaultClear()
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '处理成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    handleChange(value) {
      console.log(`selected ${value}`)
    },
    handleBlur() {
      console.log('blur')
    },
    handleFocus() {
      console.log('focus')
    },
    filterOption(input, option) {
      return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0)
    }
  }
}
</script>
